import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SectionTitle from "../SectionTitle/SectionTitle";
import { getPartners } from "../../api/Partner";


const settings = {
    dots: false,
    arrows: false,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
        {
            breakpoint: 1500,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};


const PartnerSectionS2 = (props) => {
    const [partners, setPartners] = useState(null);
    const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;
    const [hoveredIndex, setHoveredIndex] = useState(null);

    useEffect(() => {
        getPartners().then(setPartners);
    }, []);

    if (!partners) return null;

    return (
        <section 
            className={`partners-section-s2 section-padding ${props.tNone}`}
            style={{
                padding: "60px 0", // optional: ensures good spacing
                paddingTop: "40px",   // reduce vertical padding
                paddingBottom: "40px"
            }}
        >
            <div className="container">
                <SectionTitle
                    subTitle={
                        <span
                            style={{
                                color: "black"
                            }}
                        >
                            OUR HONORABLE PARTNERS
                        </span>
                    }
                    Title={
                        <span
                            style={{
                                color: "darkblue",
                                fontSize: "30px"
                            }}
                        >
                            Empowering partnerships through quality exports
                        </span>
                    }
                />
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="partner-grids partners-slider owl-carousel">
                            <style>
                                {`
                                    .slick-list {
                                        overflow: visible !important;
                                    }
                                    .slick-slide > div {
                                        margin: 10px;
                                    }
                                `}
                            </style>
                            <Slider {...settings}>
                                {partners.map((partner, pitem) => (
                                    <div 
                                        className="grid" key={pitem}
                                        style={{
                                            boxShadow: "none",
                                            border: "1px solid black"
                                        }}
                                    >
                                        <div
                                            key={pitem}
                                            className="flex items-center justify-center w-full h-44 p-2"
                                            style={{
                                                position: "relative", // ✅ ADD THIS LINE
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: "240px",
                                                height: "150px",
                                                margin: "0 auto",
                                                boxShadow: "0 4px 10px rgba(0, 0, 80, 0.6)",
                                                borderRadius: "10px",
                                                overflow: "hidden", // ✅ optional: keep overlay confined
                                            }}
                                            onMouseEnter={() => setHoveredIndex(pitem)}
                                            onMouseLeave={() => setHoveredIndex(null)}
                                        >
                                        <img
                                            src={`${apiUrl}/storage/${partner.banner}`}
                                            alt={partner.name}
                                            className="max-w-full max-h-full object-contain rounded-md transition-transform duration-300 hover:scale-105"
                                            style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            objectPosition: "center",
                                            borderRadius: "8px",
                                            filter: "none",
                                            backgroundColor: "transparent",
                                            }}
                                        />
                                        <div
                                            style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontWeight: "bold",
                                            background: hoveredIndex === pitem
                                                ? "linear-gradient(to bottom right, rgba(0, 0, 139, 0.75), rgba(70, 130, 180, 0.6), rgba(173, 216, 230, 0.4))"
                                                : "transparent",
                                            opacity: hoveredIndex === pitem ? 1 : 0,
                                            transition: "all 0.4s ease-in-out",
                                            borderRadius: "5px",
                                            padding: "0px 10px",
                                            color: "black"
                                            }}
                                        >
                                            {partner.name}
                                        </div>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default PartnerSectionS2;